<div class="header d-none d-md-block">
  <h1 class="d-inline-flex v-align-middle astral-heading-with-help">
    <span>{{ title | translate }}</span>
    <astral-popover [helpText]="'VACANT_RENTAL_OBJECT_LIST.HEADER_TOOLTIP'"></astral-popover>
  </h1>
  @if (excelReady) {
    <app-excel-list
      class="btn-list-header"
      [columnDefinition]="excelColumnDefinition"
      [selectedListViewColumns]="selectedColumns"
      [excelContext]="excelContext"
      [filter]="filterState"
      [fileName]="excelFileName"
      [selectedIds]="selectedParkingIds"
      [affectedItemsCount]="selectedParkingCount"
      [allSelected]="allParkingsSelected"
      [totalResults]="totalParkings"
    ></app-excel-list>
  }
</div>
<div class="header d-flex d-md-none align-items-center">
  <h1 class="w-100 astral-heading-with-help">
    <span>{{ title | translate }}</span>
    <astral-popover [helpText]="'VACANT_RENTAL_OBJECT_LIST.HEADER_TOOLTIP'"></astral-popover>
  </h1>
  @if (excelReady) {
    <app-excel-list
      [columnDefinition]="excelColumnDefinition"
      [selectedListViewColumns]="selectedColumns"
      [excelContext]="excelContext"
      [filter]="filterState"
      [fileName]="excelFileName"
      [selectedIds]="selectedParkingIds"
      [affectedItemsCount]="selectedParkingCount"
      [allSelected]="allParkingsSelected"
      [totalResults]="totalParkings"
      [isMobile]="true"
    ></app-excel-list>
  }
</div>

<app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>

@if (displayGroupedByProperty) {
  <div>
    <app-expanded-list-view
      [columnDefinitions]="columnGroupDefinitions"
      [itemsSource]="dataExpandedList"
      [preferencesKey]="groupedPreferencesKey"
      (rowClick)="onRowClicked($event)"
    ></app-expanded-list-view>
  </div>
}

@if (displayList) {
  <app-multiselect-list-view
    [columnDefinition]="columnDefinition"
    [itemsSource]="itemsSource"
    [contextMenuDefinition]="contextMenuDefinition"
    [menuDefinition]="menuDefinition"
    [preferencesKey]="preferencesKey"
    [rememberPagination]="true"
    (onColumnChange)="onColumnChange($event)"
    (selectedItemsChange)="onSelectedParkingsChange($event)"
    (rowClick)="onRowClicked($event)"
    [isToolbarSticky]="true"
    >
  </app-multiselect-list-view>
}
